import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Yes',
        color: COLORS.e4ImpactBlue
    },
    {
        name: 'No',
        color: COLORS.e4ImpactOrange
    }
];

/**
 * Survey: PROJECT - FINAL IMPACT
 * Question: Did you manage to increase your customer network?
 * 
 * == final
 * netw_growth_t1
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursThatIncreasedCustomerNetworkChartCalculation = (props: any) => {
    const data = transformData.map(({name, color}) => ({
        name,
        color,
        y: props.finalSubmissions.filter((submission: any) => submission.netw_growth_t1 === name).length
    }));
    const values = transformData.map(({name}) => name);

    return getDefaultPieFormatting(
        '% of entrepreneurs that increased the customer network',
        data,
        0,
        {},
    ) as Highcharts.Options;
}